import React, { useState, useEffect, useRef } from 'react';
import { Link } from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import { Button, Badge, Tooltip, OverlayTrigger, Dropdown } from "react-bootstrap";
import LightGallery from 'lightgallery/react';
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';

import breakimage from '../../../../images/auth/Front-break.jpg';
import food_map from '../../../../images/food_maps.ico';
import def_doc from '../../../../images/doc.png';
import $ from 'jquery';
import { Row, Col, Tab, Nav } from "react-bootstrap";
import break_box from '../../../../images/product/break_box.png';
import lunch_box from '../../../../images/product/meals_box.png';
import dinner_box from '../../../../images/product/dinner_box.png';
import ViewSubscription from '../../../modal/Subscription_Management/Manage_Subscriptions/ViewSubscription';
import ViewComplaint from '../../../modal/Complaint_Management/Manage_Complaints/ViewComplaint';
// import ViewComplaints from '../../../modal/Subscription_Management/Manage_Customers/ViewComplaints';
// import ViewComplaintsNewDate from '../../../modal/Subscription_Management/Manage_Customers/ViewComplaintsNewDate';
import { useLocation } from 'react-router-dom';
import axios from 'axios';

const ViewSubscriberdetails = () => {

    const location = useLocation();
    const { ID } = location.state || {};

    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const imgBaseUrl = process.env.REACT_APP_IMG_BASE_URL;

    const [datas, setData] = useState([]);
    const [hasFetched, setHasFetched] = useState(false);
    const [hasFetchedComplaints, setHasFetchedComplaints] = useState(false);
    const [subscriber_info, setSubscriberInfo] = useState({});
    const [currentSubs, setCurrentSubs] = useState({});
    const [subscription_info, setSubscriptionInfo] = useState([]);
    const [complaintData, setComplaintdata] = useState([]);

    // page table data fetch
    const fetchData = () => {
        axios.get(`${baseURL}/subscriber/${ID}`)
            .then(response => {
                setData(response.data.data);
                setSubscriberInfo(response.data.data.subscriber_info);
                setSubscriptionInfo(response.data.data.all_subscriptions);
                setCurrentSubs(response.data.data.subscriber_info.current_subscriptions);
                setHasFetched(true);
            })
            .catch(error => {
                console.log('There was an error fetching the data!', error);
                setHasFetched(true);
            });
    };

    const fetchcomplaint = () => {
        axios.get(`${baseURL}/complaint/subscribers/${ID}`)
            .then(response => {
                setComplaintdata(response.data.data);
                setHasFetchedComplaints(true);
            })
            .catch(error => {
                console.log('There was an error fetching the data!', error);
                setHasFetchedComplaints(true);
            });
    }

    // fetch data & leadstatus
    useEffect(() => {
        fetchData();
        fetchcomplaint();
    }, []);


    const onInit = () => {
        //   console.log('lightGallery has been initialized');
    };
    const handleDownload = () => {
        const link = document.createElement('a');
        link.href = def_doc;  // Set the file URL
        link.download = 'Complaints File';  // Optionally, specify the file name here
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const [key, setKey] = useState('basic_info');
    const tableRef = useRef(null);

    const [modalType, setModalType] = useState("");
    const [open, setOpen] = useState(false);

    const [selectedId, setSelecctedID] = useState("");
    const ViewSubscriptionModal = (selectedId) => {
        setSelecctedID(selectedId);
        setModalType("ViewSubscription");
        setOpen(true);
    };

    useEffect(() => {
        if (hasFetched) {
            const tables = document.querySelectorAll('.subscription_table');
            tables.forEach((table) => {
                if (!$.fn.dataTable.isDataTable(table)) {
                    $(table).DataTable({
                        "responsive": true,
                        pageLength: 25,
                        //   "aaSorting": [],
                        "ordering": false,
                    "language": {
                            "lengthMenu": "Show&nbsp;&nbsp; _MENU_",
                        },
                        "dom":
                            "<'row'" +
                            "<'col-sm-6 d-flex align-items-center justify-content-start mb-2'l>" +
                            "<'col-sm-6 d-flex align-items-center justify-content-end mb-2'f>" +
                            ">" +
                            "<'table-responsive'tr>" +
                            "<'row'" +
                            "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start mt-2'i>" +
                            "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end mt-2'p>" +
                            ">"
                    });
                }
            });
        }
    }, [hasFetched]);

    useEffect(() => {
        if (hasFetchedComplaints) {
            const tables = document.querySelectorAll('.complaint_table');
            tables.forEach((table) => {
                if (!$.fn.dataTable.isDataTable(table)) {
                    $(table).DataTable({
                        "responsive": true,
                        pageLength: 25,
                        //   "aaSorting": [],
                        "ordering": false,
                    "language": {
                            "lengthMenu": "Show&nbsp;&nbsp; _MENU_",
                        },
                        "dom":
                            "<'row'" +
                            "<'col-sm-6 d-flex align-items-center justify-content-start mb-2'l>" +
                            "<'col-sm-6 d-flex align-items-center justify-content-end mb-2'f>" +
                            ">" +
                            "<'table-responsive'tr>" +
                            "<'row'" +
                            "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start mt-2'i>" +
                            "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end mt-2'p>" +
                            ">"
                    });
                }
            });
        }
    }, [hasFetchedComplaints]);

    const [selectedRow, setSelectedRow] = useState({});
    const handleModalToggle_view = (data) => {
        setSelectedRow(data);
        setModalType("ViewComplaint");
        setOpen(true);
    };


    return (
        <>
            <div className="d-flex align-items-center justify-content-between page-titles px-0 py-1 mb-3 mx-0">
                <div className='mb-0'>
                    <div className="mb-0 px-0">
                        <h4 style={{ color: '#025d3a' }}>View Subscriber</h4>
                    </div>
                    <ol className="breadcrumb fs-7">
                        <li className="breadcrumb-item"><Link to='/dashboard'>Dashboard</Link></li>
                        <li className="breadcrumb-item"><i className="fa-solid fa-angles-right fs-8"></i></li>
                        <li className="breadcrumb-item">Subscription Management</li>
                        <li className="breadcrumb-item"><i className="fa-solid fa-angles-right fs-8"></i></li>
                        <li className="breadcrumb-item active"><Link to='/manage-order'>Manage Order</Link></li>
                    </ol>
                </div>
                <div className='mb-0'>
                    <div className='fs-5 font-w500 text-black'>
                        <span className='me-2'><i className='fas fa-user fs-4 text-info'></i></span>
                        <span>{subscriber_info.name}</span>
                    </div>
                    <div className='d-block'>
                        <label className='fs-7 font-w500 text-black'>
                            <span className='me-2'><i className='fas fa-phone fs-4 text-info'></i></span>
                            <span>{subscriber_info.mobile_no}</span>
                        </label>
                    </div>
                </div>

                {open && modalType === "ViewSubscription" && (
                    <ViewSubscription show={open} onClose={() => setOpen(false)} selectedId={selectedId} />
                )}

                {open && modalType === "ViewComplaint" && (
                    <ViewComplaint show={open} onClose={() => setOpen(false)} data={selectedRow} />
                )}

            </div>
            <Col xl={12} className='mb-3'>
                <div className="custom-tab-1">
                    <Tab.Container activeKey={key} onSelect={(k) => setKey(k)}>
                        <Nav as="ul" className="nav-tabs">
                            <Nav.Item as="li" >
                                <Nav.Link eventKey="basic_info">
                                    <i className="fa-regular fa-user me-2" />
                                    <span className="ms-2 fs-6">
                                        Basic Information
                                    </span>

                                </Nav.Link>
                            </Nav.Item>
                            <Nav.Item as="li" >
                                <Nav.Link eventKey="subs_details">
                                    <i className="fa-regular fa-money-bill-1 me-2" />
                                    <span className="ms-2 fs-6">
                                        Subscription Details
                                    </span>
                                </Nav.Link>
                            </Nav.Item>
                            <Nav.Item as="li" >
                                <Nav.Link eventKey="payment_details">
                                    <i className="fa-regular fa-money-bill-1 me-2" />
                                    <span className="ms-2 fs-6">
                                        Payment Details
                                    </span>
                                </Nav.Link>
                            </Nav.Item>
                            <Nav.Item as="li" >
                                <Nav.Link eventKey="complaints_details">
                                    <i className="fa-regular fa-hand-point-up fs-7 me-2"></i>
                                    <span className="ms-2 fs-6">
                                        Complaints Details
                                    </span>
                                </Nav.Link>
                            </Nav.Item>
                        </Nav>
                        <Tab.Content className="pt-4">
                            <Tab.Pane eventKey="basic_info">
                                <Col xl={12}>
                                    <div className='row mb-4'>
                                        <div className='col-lg-3 mb-2'>
                                            <div className='fs-6 font-w500 text-black'>
                                                <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span>Subscriber Name</span></Tooltip>} >
                                                    <span className='me-3'><i className='fa-regular fa-circle-user fs-4'></i></span>
                                                </OverlayTrigger>
                                                <span>{subscriber_info.name}</span>
                                            </div>
                                        </div>

                                        <div className='col-lg-3 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                            <div className='fs-6 font-w500 text-black'>
                                                <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span>Mobile No</span></Tooltip>} >
                                                    <span className='me-3'><i className='fa-solid fa-phone fs-4'></i></span>
                                                </OverlayTrigger>
                                                <span>{subscriber_info.mobile_no}</span>
                                            </div>
                                        </div>
                                        <div className='col-lg-3 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                            <div className='fs-6 font-w500 text-black'>
                                                <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span>Email ID</span></Tooltip>} >
                                                    <span className='me-3'><i className='fa-solid fa-envelope-open-text fs-4'></i></span>
                                                </OverlayTrigger>
                                                <span>{subscriber_info.email ? subscriber_info.email : '-'}</span>
                                            </div>
                                        </div>
                                        <div className='col-lg-3 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                            <div className='fs-6 font-w500 text-black'>
                                                <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span>Area</span></Tooltip>} >
                                                    <span className='me-3'><i className='fa-solid fa-chart-area fs-4'></i></span>
                                                </OverlayTrigger>
                                                <span>{subscriber_info.area ? subscriber_info.area : '-'}</span>
                                            </div>
                                        </div>
                                        <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                            <div className='fs-6 font-w500 text-black'>
                                                <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span>Address</span></Tooltip>} >
                                                    <span className='me-3'><i className='fa-solid fa-location-crosshairs fs-4'></i></span>
                                                </OverlayTrigger>
                                                <span>{subscriber_info.address ? subscriber_info.address : '-'}</span>
                                            </div>
                                        </div>
                                        <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                            <div className='fs-6 font-w500 text-black'>
                                                <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span>Description</span></Tooltip>} >
                                                    <span className='me-3'><i className='fa-solid fa-arrows-to-circle fs-4'></i></span>
                                                </OverlayTrigger>
                                                <span>{subscriber_info.description ? subscriber_info.description : '-'}</span>
                                            </div>
                                        </div>
                                    </div>
                                    {currentSubs.length > 0 && (
                                        <div className="row">
                                            <div className='fs-4 text-danger fw-bold mb-4'>Current Subscription Details</div>
                                                {currentSubs.map((data, index) => (
                                                    <div className="col-lg-4" key={index}>
                                                        <div className="card h-100 mb-2">
                                                            <div className='card-header bg-danger-light d-block py-2 px-3'>
                                                                <div className='d-flex align-items-center justify-content-between'>
                                                                    <div className='text-info fs-4 fw-bold'>{data.product_name}</div>
                                                                    <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Food Map</span></Tooltip>} >
                                                                        <Link to={'/food-map'}>
                                                                            <img
                                                                                src={food_map}
                                                                                alt="Food Map"
                                                                                className='w-45px h-45px'
                                                                            />
                                                                        </Link>
                                                                    </OverlayTrigger>
                                                                </div>
                                                            </div>
                                                            <div className="card-body pt-2 pb-0 px-3">
                                                                <div className="promo-bx">
                                                                    <div className="d-flex align-items-center justify-content-between flex-wrap mb-3">
                                                                        <div className="d-flex align-items-center mb-2">
                                                                            <LightGallery
                                                                                onInit={onInit}
                                                                                speed={500}
                                                                                plugins={[lgThumbnail, lgZoom]}
                                                                                elementClassNames="me-2"
                                                                            >
                                                                                <div data-src={(imgBaseUrl && data.product_image) ? imgBaseUrl + '/' + data.product_image : breakimage} className="border rounded px-1 py-1 d-flex align-items-center" >
                                                                                    <img src={(imgBaseUrl && data.product_image) ? imgBaseUrl + '/' + data.product_image : breakimage} style={{ width: "100%" }} alt="gallery" className='cursor-pointer w-60px h-60px' />
                                                                                </div>
                                                                            </LightGallery>
                                                                            <div className='mb-0'>
                                                                                <label className='text-black font-w400 fs-5'>{data.duration_name}</label>
                                                                                <div className='d-block'>
                                                                                    <label className='text-dark font-w400 fs-6'>{data.duration_days} Days</label>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div>
                                                                            <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Service Time</span></Tooltip>} >
                                                                                <Badge bg="none" className='fs-6 py-1 px-1 border'>
                                                                                    <div className='fs-7 text-success'>{data.start_time}</div>
                                                                                    <div className='d-block fs-7 text-danger'>{data.end_time}</div>
                                                                                </Badge>
                                                                            </OverlayTrigger>
                                                                        </div>
                                                                    </div>
                                                                    
                                                                    <div className='d-flex align-items-center justify-content-between flex-wrap mb-4'>
                                                                        <div className='mb-1'>
                                                                            <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Service Start Date</span></Tooltip>} >
                                                                                <div className='mb-0'>
                                                                                    <span className='text-black'>
                                                                                        <i className="far fa-calendar fs-4 me-2"></i>
                                                                                    </span>
                                                                                    <span className='text-success fw-bold fs-6'>{data.start_date}</span>
                                                                                </div>
                                                                            </OverlayTrigger>
                                                                        </div>
                                                                        <div className='mb-1'>
                                                                            <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Service End Date</span></Tooltip>} >
                                                                                <div className='mb-0'>
                                                                                    <span className='text-black'>
                                                                                        <i className="far fa-calendar fs-4 me-2"></i>
                                                                                    </span>
                                                                                    <span className='text-danger fw-bold fs-6'>{data.end_date}</span>
                                                                                </div>
                                                                            </OverlayTrigger>
                                                                        </div>
                                                                    </div>
                                                                    <div className='row'>
                                                                        <div className='col-lg-12 mb-2'>
                                                                            <div className='text-green font-w500 fs-1 text-center'>
                                                                                <label><i className="fa-solid fa-indian-rupee-sign fs-2 me-2"></i></label>
                                                                                <label>{data.price}</label>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                        </div>
                                    )}
                                </Col>
                            </Tab.Pane>
                            
                            <Tab.Pane eventKey="subs_details">
                                <Row>
                                    <Col xl={12}>
                                        <div className="table-container">
                                            <table ref={tableRef} className="subscription_table table align-top table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable">
                                                <thead>
                                                    <tr className="text-start text-muted fw-bold fs-6 gs-0 th_head">
                                                        <th className='min-w-150px'>Products</th>
                                                        <th className='min-w-80px'>Duration</th>
                                                        <th className='min-w-100px'>Area /
                                                            <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Delivery Point</span></Tooltip>} >
                                                                <span>D.Points</span>
                                                            </OverlayTrigger>
                                                        </th>
                                                        <th className='min-w-100px'>Address</th>
                                                        <th className='min-w-100px text-center'>Delivery</th>
                                                        <th className='min-w-80px text-start'>Amount</th>
                                                        <th className='min-w-100px'>Status</th>
                                                        <th className='min-w-50px text-end'>Actions</th>
                                                    </tr>
                                                </thead>
                                                <tbody className="text-gray-600 fw-semibold fs-7">
                                                    {subscription_info.map((data, index) => (
                                                        <tr key={index}>
                                                            <td>
                                                                <div className="d-flex align-items-center justify-content-start gap-2">
                                                                    <LightGallery
                                                                        onInit={onInit}
                                                                        speed={500}
                                                                        plugins={[lgThumbnail, lgZoom]}
                                                                    >
                                                                        <div data-src={(imgBaseUrl && data.product_image) ? imgBaseUrl + '/' + data.product_image : break_box} className='border rounded px-1 py-0'>
                                                                            <img src={(imgBaseUrl && data.product_image) ? imgBaseUrl + '/' + data.product_image : break_box} alt="Break Box" className='cursor-pointer w-45px h-45px' />
                                                                        </div>
                                                                    </LightGallery>
                                                                    <div>
                                                                        <label className='text-black font-w400 fs-7'>{data.product_name}</label>
                                                                        <div className="d-block">
                                                                            <div className="fs-8 font-w600 text-dark">{data.duration_name} ({data.duration_days} Days)</div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <label className='text-success fw-bold fs-7'>{data.start_date}</label>
                                                                <div className='d-block'>
                                                                    <label className='text-danger fw-bold fs-7'>{data.end_date}</label>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className='text-black font-w400 fs-7 text-wrap mw-auto'>{data.area_name}</div>
                                                                <div className="d-block">
                                                                    <div className="fs-8 text-dark font-w500 text-wrap mw-auto">{data.deliverypoint}</div>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className='text-black font-w400 fs-7 text-wrap mw-auto'>{data.address ? data.address : '-'}
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className='d-flex align-items-center gap-2 justify-content-center'>
                                                                    <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Balance Delivery</span></Tooltip>} >
                                                                        <Badge bg="danger" className='text-white fs-8 py-0 px-1 cursor-pointer'>{data.balance}</Badge>
                                                                    </OverlayTrigger>
                                                                    <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Delivered</span></Tooltip>} >
                                                                        <Badge bg="success" className='text-white fs-8 py-0 px-1 cursor-pointer'>{data.delivered}</Badge>
                                                                    </OverlayTrigger>
                                                                    <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Total Delivery</span></Tooltip>} >
                                                                        <Badge bg="info" className='text-white fs-8 py-0 px-1 cursor-pointer'>{data.total_delivery}</Badge>
                                                                    </OverlayTrigger>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className='text-end'>
                                                                    <label className="fs-6 text-danger fw-bold">
                                                                        <span><i className="fa-solid fa-indian-rupee-sign me-2"></i></span>
                                                                        <span>{data.price}</span>
                                                                    </label>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                {data.status != 5 && (
                                                                    <Badge bg="success" className='text-white fs-7 py-0 px-1'>Active</Badge>
                                                                )}
                                                                {data.status == 5 && (
                                                                    <Badge bg="danger" className='text-white fs-7 py-0 px-1'>Expired</Badge>
                                                                )}
                                                            </td>
                                                            <td>
                                                                <div className="text-end">
                                                                    <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>View</span></Tooltip>} >
                                                                        <Button variant="primary tp-btn-light px-2 py-1 me-1" onClick={() => ViewSubscriptionModal(data.sno)}>
                                                                            <span><i className="fa fa-eye fs-6 mt-1"></i></span>
                                                                        </Button>
                                                                    </OverlayTrigger>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </Col>
                                </Row>
                            </Tab.Pane>

                            <Tab.Pane eventKey="payment_details">
                                <Row>
                                    <Col xl={12}>
                                        <div className="table-container">
                                            <table ref={tableRef} className="subscription_table table align-top table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable">
                                                <thead>
                                                    <tr className="text-start text-muted fw-bold fs-6 gs-0 th_head">
                                                        <th className='min-w-100px'>Date / Time</th>
                                                        {/* <th className='min-w-100px'>Payment Time</th> */}
                                                        <th className='min-w-100px'>Products</th>
                                                        <th className='min-w-100px'>Duration</th>
                                                        <th className='min-w-100px'>Amount</th>
                                                        <th className='min-w-100px text-start'>Payment Status</th>
                                                        <th className='min-w-100px text-start'>Transaction Mode</th>
                                                    </tr>
                                                </thead>
                                                <tbody className="text-gray-600 fw-semibold fs-7">
                                                    {subscription_info.map((data, index) => (
                                                        <tr key={index}>
                                                            <td>
                                                                <label className='text-black font-w400 fs-7'>{data.payment_date}</label>
                                                                <div className='d-block'>
                                                                    <label className='text-dark font-w600 fs-8'>{data.payment_time}</label>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className="d-flex align-items-center justify-content-start gap-2">
                                                                    <LightGallery
                                                                        onInit={onInit}
                                                                        speed={500}
                                                                        plugins={[lgThumbnail, lgZoom]}
                                                                    >
                                                                        <div data-src={(imgBaseUrl && data.product_image) ? imgBaseUrl + '/' + data.product_image : lunch_box} className='border rounded px-1 py-0'>
                                                                            <img src={(imgBaseUrl && data.product_image) ? imgBaseUrl + '/' + data.product_image : lunch_box} alt={data.product_name} className='cursor-pointer w-45px h-45px' />
                                                                        </div>
                                                                    </LightGallery>
                                                                    <div className='mb-0'>
                                                                        <label className='text-black font-w400 fs-7'>{data.product_name}</label>
                                                                        <div className="d-block">
                                                                            <div className="fs-8 font-w600 text-dark">{data.duration_name} ({data.duration_days} Days)</div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <label className='text-success font-w600 fs-7 me-2'>{data.start_date}</label>
                                                                <div className='d-block'>
                                                                    <label className='text-danger font-w600 fs-7'>{data.end_date}</label>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className='text-end'>
                                                                    <label className="fs-6 text-danger fw-bold">
                                                                        <span><i className="fa-solid fa-indian-rupee-sign me-2"></i></span>
                                                                        <span>{data.price}</span>
                                                                    </label>
                                                                </div>
                                                            </td>
                                                            <td className='text-center'>
                                                                {data.payment_process !== 1 ? (
                                                                    <>
                                                                        <span className="text-white fs-7 py-0 px-1 badge bg-success">Paid</span>
                                                                    </>
                                                                ) : (
                                                                    <>
                                                                        <span className="text-white fs-7 py-0 px-1 badge bg-danger">Pending</span>
                                                                    </>
                                                                )}
                                                            </td>
                                                            <td className='text-center'>
                                                                {data.payment_process !== 1 ? (
                                                                    <>
                                                                    <label className='text-black font-w400 fs-7'>{data.payment_mode_name}</label>
                                                                    { data.transaction_id && (
                                                                        <div className='d-block'>
                                                                            <label className='text-dark font-w600 fs-8'>{data.transaction_id}</label>
                                                                        </div>
                                                                    )}
                                                                    </>
                                                                ) : (
                                                                    '-'
                                                                )}
                                                            </td>
                                                        </tr>
                                                    ))}

                                                </tbody>
                                            </table>
                                        </div>
                                    </Col>
                                </Row>
                            </Tab.Pane>

                            <Tab.Pane eventKey="complaints_details">
                                <Row>
                                    <Col xl={12}>
                                        <div className="table-container">
                                            <table ref={tableRef} className="complaint_table table align-top table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable">
                                                <thead>
                                                    <tr className="text-start text-muted fw-bold fs-6 gs-0 th_head">
                                                        <th className='min-w-100px'>Date</th>
                                                        <th className='min-w-100px'>Packages</th>
                                                        <th className='min-w-100px'>Complaint Type</th>
                                                        <th className='min-w-100px'>Complaints</th>
                                                        <th className='min-w-100px'>Status</th>
                                                        <th className='min-w-50px text-end'>Actions</th>
                                                    </tr>
                                                </thead>
                                                <tbody className="text-gray-600 fw-semibold fs-7">
                                                    {complaintData.map((data, index) => (
                                                    <tr key={index}>
                                                        <td>
                                                            <div className='text-black font-w400 fs-7'>{data.date}</div>
                                                            <div className='d-block'>
                                                                <div className='text-danger font-w600 fs-8'>{data.time}</div>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className='text-black font-w400 fs-7 text-wrap mw-auto'>{data.product_name}</div>
                                                            <div className="d-block">
                                                                <div className="fs-8 text-dark font-w500 text-wrap mw-auto">{data.timeline_name} ( {data.timeline_duration} Days )</div>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <label className='text-danger font-w700 fs-7'>{data.c_type_name}</label>
                                                        </td>
                                                        <td>
                                                            <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>{data.complaint_convo}</span></Tooltip>} >
                                                                <div className='text-black font-w400 text-justify text-truncate mw-150px fs-7'>{data.complaint_convo}</div>
                                                            </OverlayTrigger>
                                                        </td>
                                                        <td>
                                                            {data.complaint_status === 0 && (
                                                                <Badge bg="danger" className='text-white fs-7 py-0 px-1'>Open</Badge>
                                                            )}
                                                            {data.complaint_status === 1 && (
                                                                <Badge bg="info" className='text-white fs-7 py-0 px-1'>In Progress</Badge>
                                                            )}
                                                            {data.complaint_status === 2 && (
                                                                <Badge bg="success" className='text-white fs-7 py-0 px-1'>Resolved</Badge>
                                                            )}
                                                            {data.complaint_status === 3 && (
                                                                <Badge bg="success" className='text-white fs-8 py-1 px-2'>Closed</Badge>
                                                            )}
                                                        </td>
                                                        <td>
                                                            <span className="text-end">
                                                                <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>View</span></Tooltip>} >
                                                                    <Button variant="primary tp-btn-light px-2 py-1 me-1" onClick={() => handleModalToggle_view(data)}>
                                                                        <span><i className="fa fa-eye fs-6 mt-1"></i></span>
                                                                    </Button>
                                                                </OverlayTrigger>
                                                            </span>
                                                        </td>
                                                    </tr>
                                                    ))}
                                                    {/* <tr>
                                                        <td>
                                                            <div className='text-black font-w400 fs-7'>20-Feb-2025</div>
                                                            <div className='d-block'>
                                                                <div className='text-danger font-w600 fs-8'>05:00 PM</div>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div className='text-black font-w400 fs-7 text-wrap mw-auto'>Lunch Box Regular</div>
                                                            <div className="d-block">
                                                                <div className="fs-8 text-dark font-w500 text-wrap mw-auto">Weekly ( 7 Days )</div>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <label className='text-danger font-w700 fs-7'>Food / Taste</label>
                                                        </td>
                                                        <td>
                                                            <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>no added vegetables in sambar than kulamu varities only plain(sundal,urundai kulambu)</span></Tooltip>} >
                                                                <div className='text-black font-w400 text-justify text-truncate mw-150px fs-7'>no added vegetables in sambar than kulamu varities only plain(sundal,urundai kulambu)</div>
                                                            </OverlayTrigger>
                                                        </td>
                                                        <td>
                                                            <label onClick={handleDownload} className="ms-2 text-danger" style={{ cursor: 'pointer' }}>
                                                                <img
                                                                    src={def_doc}
                                                                    alt="document"
                                                                    className='w-40px h-40px'
                                                                />
                                                            </label>
                                                        </td>
                                                        <td>
                                                            <Badge bg="success" className='text-white fs-7 py-0 px-1'>Closed</Badge>
                                                        </td>
                                                        <td>
                                                            <div className="text-end">
                                                                <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>View</span></Tooltip>} >
                                                                    <Button variant="primary tp-btn-light px-2 py-1 me-1" >
                                                                        <span><i className="fa fa-eye fs-6 mt-1"></i></span>
                                                                    </Button>
                                                                </OverlayTrigger>
                                                            </div>
                                                        </td>
                                                    </tr> */}
                                                </tbody>
                                            </table>
                                        </div>
                                    </Col>
                                </Row>
                            </Tab.Pane>
                        </Tab.Content>
                    </Tab.Container>
                </div>
            </Col>
        </>
    )

}
export default ViewSubscriberdetails;